<template>
    <div id="purchaseOrderManage">
        <el-row class="clearfix" style="margin-bottom: 15px;">
            <el-col class="fl" :span="2"><el-button size="medium" type="success" @click="createOrder()" v-if="basicsAuth.purchaseOrdersAdd">新建采购订单</el-button></el-col>
            <el-col class="fr" :span="1">
                <i class="el-icon-refresh" style="font-size: 25px;cursor: pointer;" @click="refresh()"></i>
            </el-col>
        </el-row>
        <el-col class="fl searthPart" style="width: 18.5%;">
            <ul>
                <li v-for="(item,index) in orderLists" :key="index" class="clearfix orderListsLi" @click="toViewOrder(item,index)" :class="{highLight:activeIndex === index}">
                    <span>{{item.name}}</span>
                    <span>{{item.number}}</span>
                </li>
            </ul>
            <p class="headerT">检索条件：</p>
            <el-form ref="searchForm" :model="searchForm" label-width="75px" :label-position="labelPosition">
                <el-select filterable style="margin-bottom: 15px;width:100%" clearable v-model="searchForm.createUser" placeholder="请选择创建人">
                    <el-option v-for="(item,index) in pickingUserAllList" 
                        :label="item.staffName" 
                        :value="item.staffName" 
                        :key="index">
                    </el-option>
                </el-select>
                <el-input clearable v-model.trim="searchForm.code" placeholder="请输入采购订单编号" style="margin-bottom: 15px;"></el-input>
                <el-input clearable v-model.trim="searchForm.supplierName" placeholder="请输入供应商名称" style="margin-bottom: 15px;"></el-input>
                <el-form-item label="采购日期:">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="valueTime1"
                        type="daterange"
                        range-separator="-"
                        :default-time="['00:00:00', '11:59:59']"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="交货日期:">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="valueTime2"
                        type="daterange"
                        range-separator="-"
                        :default-time="['00:00:00', '11:59:59']"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="创建日期:">
                    <el-date-picker
                        style="width: 100%;"
                        v-model="valueTime3"
                        type="daterange"
                        range-separator="-"
                        :default-time="['00:00:00', '11:59:59']"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-button type="success" @click="onSubmit('searchForm')" style="width:100%;margin-top: 20px;">检索采购订单</el-button>
                <el-button type="text" @click="clearFrom()" class="fr" style="width: 60px;color: #169BD5;">重置</el-button>
            </el-form>
        </el-col>
        <el-col class="fr" style="width: 79.5%;">
            <el-card class="box-card fr" style="width: 100%;">
                <el-table
                    :data="supplierData"
                    border
                    :header-cell-style="{'text-align':'center'}"
                    style="width: 100%"
                    @row-click="goToDetail">
                    <el-table-column
                        align="center"
                        prop="code"
                        width="200"
                        label="采购订单编号">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="120"
                        prop="supplierName"
                        label="供应商名称">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="paymentTime"
                        width="100"
                        label="账期">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="purchaseTime"
                        width="120"
                        label="采购日期"
                        :formatter="dateFormat">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="aogTime"
                        width="120"
                        label="预期交货日期"
                        :formatter="dateFormat">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="amout"
                        width="150"
                        label="采购总金额(元)"
                        :formatter="addCommas">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="aogPercentage"
                        width="150"
                        label="到货百分比">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="status"
                        label="状态">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="120"
                        prop="createUser"
                        label="创建人">
                    </el-table-column>
                    <el-table-column
                        align="center"
                        width="120"
                        prop="createTime"
                        :formatter="dateFormat"
                        label="创建时间">
                    </el-table-column>
                </el-table>
            </el-card>
            <!--分页-->
            <el-col :span="24" class="toolbar">
                <div class="pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pages.page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pages.pageSize"
                        layout="total, sizes, prev, pager, next,jumper"
                        :total="pages.total">
                    </el-pagination>
                </div>
            </el-col>
        </el-col>
    </div>
</template>

<script>
    let moment = require("moment");
    import {
      getpurchaseOrdersList,
      queryUser
    } from "../../api/api";
    import {getPermission} from '../../api/authRequest';
    export default {
        name: 'purchaseOrderManage',
        components: {},
        data () {
            return {
                orderId:'',
                valueTime1:[],
                valueTime2:[],
                valueTime3:[],
                allOrder:'',
                CGSUM:'',
                YWCSUM:'',
                ZTSUM:'',
                activeIndex: 0,
                defaultOrderStatus:'',
                pickingUserAllList:[],
                orderLists:[
                    {
                        name: '全部订单',
                        number: 0,
                        status:''
                    },
                    {
                        name: '在途订单',
                        number: 0,
                        status:'ZT'
                    },
                    {
                        name: '已完成订单',
                        status:'YWC',
                        number: 0,
                    },
                ],
                //分页变量
                pages:{
                    total: 0,
                    page: 1,
                    pageSize: 10,
                },
                labelPosition:'left',
                supplierForm:{
                    supplier_name: '',
                    supplier_contacts: '',
                    supplier_phone:'',
                    supplier_address:'',
                    time_out: '',
                    supplier_status: true,
                },
                searchForm:{
                    purchaseIimeStart: '',
                    purchaseIimeEnd: '',
                    aogTimeStart:'',
                    aogTimeEnd:'',
                    createTimeStart:'',
                    createTimeEnd:'',
                    code: '',
                    supplierName: '',
                    createUser: '',
                },
                supplierData: [
                    {
                        code:'',
                        supplierName:'',
                        paymentTime:'',
                        purchaseTime:'',
                        aogTime:'',
                        amout:'',
                        aogPercentage:'',
                        status:'',
                        createUser:'',
                        createTime:'',
                    },
                ],
                basicsAuth:{
                    purchaseOrdersAdd:false,
                    purchaseOrdersClose:false
                }


            }
        },
        created:function(){
            this.$destroy();
            this.basicsAuth.purchaseOrdersAdd= getPermission('/api/purchase/purchaseOrdersAdd');
            this.basicsAuth.purchaseOrdersClose= getPermission('/api/purchase/purchaseOrdersClose');
        },
        mounted () {
            this.queryUserAllList();
            this.getPurchaseOrdersList();
        },
        methods: {
            //查询所有系统账号
            queryUserAllList(){
                queryUser({type:2}).then(res =>{
                    if(res.data.status == '100'){
                        this.pickingUserAllList = res.data.results
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            clearFrom(){
                this.searchForm = {}
                this.valueTime1 = []
                this.valueTime2 = []
                this.valueTime3 = []
            },
            //获取采购管理列表
            getPurchaseOrdersList(){
                let para={
                    aogTimeStart: this.searchForm.aogTimeStart,
                    aogTimeEnd: this.searchForm.aogTimeEnd,
                    createTimeStart: this.searchForm.createTimeStart,
                    createTimeEnd: this.searchForm.createTimeEnd,
                    purchaseIimeStart: this.searchForm.purchaseIimeStart,     
                    purchaseIimeEnd: this.searchForm.purchaseIimeEnd,
                    code: this.searchForm.code,
                    supplierName: this.searchForm.supplierName,
                    createUser: this.searchForm.createUser,
                    status: this.defaultOrderStatus,
                    startRow: this.pages.page,
                    pageSize: this.pages.pageSize
                }
                getpurchaseOrdersList(para).then(res => {          
                    if (res.data.status==100) {            
                        // console.log(res.data.results.pageInfo.list)  
                        this.supplierData = res.data.results.pageInfo.list
                        this.orderLists[0].number = res.data.results.CGSUM + res.data.results.YWCSUM + res.data.results.ZTSUM
                        this.orderLists[1].number = res.data.results.ZTSUM
                        this.orderLists[2].number = res.data.results.YWCSUM
                        // this.orderLists[3].number = res.data.results.CGSUM
                        this.pages.total = res.data.results.pageInfo.total
                    }else{
                        this.$message({
                            message: res.data.message,
                            type: "error"
                        });
                    }
                }).catch((error) =>{
                    this.$Message.error(error.message);
                })
            },
            //金额转化函数
            addCommas:function(row,column){
                var num = row[column.property];
                var b= num.toString().replace(/\$|\,/g,'');
                if(isNaN(num))
                  num = "0";
                var sign = (num == (num = Math.abs(num)));
                num = Math.floor(num*100+0.50000000001);
                var cents = num%100;
                num = Math.floor(num/100).toString();
                if(cents<10)
                cents = "0" + cents;
                for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
                num = num.substring(0,num.length-(4*i+3))+','+
                num.substring(num.length-(4*i+3));
                return (((sign)?'':'-') + num + '.' + cents);
            },
            //时间转化函数
            dateFormat:function(row, column) {
                var date = row[column.property];
                if (date == undefined) {
                    return "";
                }
                return moment(date).format("YYYY-MM-DD");
            },
            handleSizeChange(val) {
                this.pages.pageSize = val
                this.getPurchaseOrdersList()
            },
            handleCurrentChange(Page) {
                this.pages.page = Page
                this.getPurchaseOrdersList()
            },
            //查看订单
            toViewOrder(item,index) {
                this.activeIndex = index
                // console.log(item.status)
                this.defaultOrderStatus = item.status
                this.getPurchaseOrdersList()
            },
            //进入详情页面
            goToDetail(row) {
                // console.log(row.status)
                this.orderId = row.id
                if (row.status !=='草稿') {
                    this.$router.push({
                        path:'/purchaseOrderInfo',
                        query:{
                            orderId:this.orderId
                        }
                    })
                } 
            },
            //新建采购订单
            createOrder() {
                this.$router.push({
                    path:'/newPurchaseOrder',
                        // query:{
                        //   orderIdUrl:orderIdUrl
                        // }
                })
            },
            refresh() {
                this.activeIndex = 0;
                this.defaultOrderStatus = ''
                this.searchForm = {}
                this.getPurchaseOrdersList()
            },
            newSupplierSubmit() {
                alert('确认提交')
            },
            onSubmit(formname) {
                this.$refs[formname].validate((valid) => {
                    if (valid) {
                        if(this.valueTime1 == null){
                            this.searchForm.purchaseIimeStart = ''
                            this.searchForm.purchaseIimeEnd = ''
                        }else if (this.valueTime1.length == 0) {
                            this.searchForm.purchaseIimeStart = ''
                            this.searchForm.purchaseIimeEnd = ''
                        }else{
                            this.searchForm.purchaseIimeStart = this.moment(this.valueTime1[0]).format("YYYY-MM-DD");
                            this.searchForm.purchaseIimeEnd = this.moment(this.valueTime1[1]).format("YYYY-MM-DD");
                        }
                      
                        if (this.valueTime2 == null) {
                            this.searchForm.aogTimeStart = ''
                            this.searchForm.aogTimeEnd = ''
                        }else if(this.valueTime2.length == 0){
                            this.searchForm.aogTimeStart = ''
                            this.searchForm.aogTimeEnd = ''
                        }else{
                            this.searchForm.aogTimeStart = this.moment(this.valueTime2[0]).format("YYYY-MM-DD");
                            this.searchForm.aogTimeEnd = this.moment(this.valueTime2[1]).format("YYYY-MM-DD");
                        }
                        if (this.valueTime3 == null) {
                            this.searchForm.createTimeStart = ''
                            this.searchForm.createTimeEnd = ''
                        }else if(this.valueTime3.length == 0){
                            this.searchForm.createTimeStart = ''
                            this.searchForm.createTimeEnd = ''
                        }else{
                            this.searchForm.createTimeStart = this.moment(this.valueTime3[0]).format("YYYY-MM-DD");
                            this.searchForm.createTimeEnd = this.moment(this.valueTime3[1]).format("YYYY-MM-DD");
                        }
                            this.getPurchaseOrdersList()
                    } else {
                        console.log('验证未通过');
                        return false;
                    }
                });
            }
        },
        computed: {},
        watch: {}
    }
</script>

<style type="text/css" lang="scss" scoped>
    #purchaseOrderManage{
        font-size: 14px;
        .headerT{
            margin:0 0 15px 0;
        }
        .orderListsLi{
            border:1px solid #c6c6c6;
            border-radius: 5px;
            margin-bottom: 15px;
            line-height: 35px;
            padding: 0 20px;
            cursor: pointer;
            & > span:first-child{
                float:left;
            }
            & > span:last-child{
                float:right;
            }
        }
        .orderListsLi.highLight{
            background-color: #1abc9c;
            border-color: #fff;
            color: #fff;
        }
        tr.el-table__row{
            cursor: pointer;
        }
        .toolbar{
            margin: 20px 0;
        }
        input.el-input__inner{
            padding-right:25px; 
        }
    }
</style>



// WEBPACK FOOTER //
// purchaseOrderManage.vue?ea1d013a